export default __webpack_public_path__ + "static/media/modal05.6101f487.png";